import { alpha } from '@mui/material/styles';

// Shared definition of the "attention" lead time: an item is considered
// inside its attention window once its due moment is this many minutes away.
export const ATTENTION_WINDOW_MINUTES = 15;
export const ATTENTION_WINDOW_MS = ATTENTION_WINDOW_MINUTES * 60 * 1000;

// Diagonal warning/attention stripes, reusable across any "attention view".
// Returns a CSS background string that layers the stripes over the given base
// colour, so it can be dropped straight into an MUI `sx.background` value.
export const attentionStripeBackground = (theme, { color = 'warning', baseColor } = {}) => {
  const palette = theme.palette[color] || theme.palette.warning;
  const isLight = theme.palette.mode === 'light';
  const stripe = alpha(palette.main, isLight ? 0.16 : 0.26);
  const base = baseColor || theme.palette.background.paper;
  return (
    `repeating-linear-gradient(135deg, ${stripe} 0, ${stripe} 12px, transparent 12px, transparent 24px),` +
    ` ${base}`
  );
};
